import { useState } from 'react';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';

const VerificationBanner = ({ onDismiss }) => {
  const { resendVerification, user } = useAuth();
  const [sending, setSending] = useState(false);

  const handleResend = async () => {
    setSending(true);
    try {
      const result = await resendVerification();
      if (result.success) {
        toast.success('Verification email sent! Check your inbox.');
      } else {
        toast.error(result.error || 'Failed to send verification email');
      }
    } catch (err) {
      toast.error('Failed to send verification email');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-amber-50 border-b border-amber-200">
      <div className="max-w-7xl mx-auto py-3 px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <div className="flex items-center gap-2">
            <svg
              className="w-5 h-5 text-amber-600 flex-shrink-0"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
            <p className="text-sm text-amber-800">
              <span className="font-medium">Verify your email</span>
              <span className="hidden sm:inline"> to unlock all features like tailoring resumes and capturing jobs.</span>
              <span className="sm:hidden"> to unlock all features.</span>
              {user?.email && (
                <span className="text-amber-600 ml-1">({user.email})</span>
              )}
            </p>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={handleResend}
              disabled={sending}
              className="text-sm font-medium text-amber-800 hover:text-amber-900 underline disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {sending ? 'Sending...' : 'Resend email'}
            </button>
            {onDismiss && (
              <button
                onClick={onDismiss}
                className="text-amber-600 hover:text-amber-800"
                aria-label="Dismiss"
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

VerificationBanner.propTypes = {
  onDismiss: PropTypes.func
};

export default VerificationBanner;
